// LCTO-1614: teto de espera pela classificação automática do documento.
//
// Enquanto o arquivo está em `classifying`, a pergunta fica bloqueada e o front
// segue consultando o servidor. Se o n8n nunca responder, o arquivo nunca
// destravaria — o texto já foi extraído, então depois do teto tratamos como
// processado e a substituição volta a ser escolha manual.
//
// Usado nos dois lados: no card do arquivo (rótulo e pendência) e no laço de
// polling da entrevista. Manter em um lugar só evita que um destrave e o outro
// continue preso.
export const CLASSIFICATION_TIMEOUT_MS = 2 * 60 * 1000

export const classificationExpired = (
    classificationRequestedAt?: string | null
): boolean => {
    if (!classificationRequestedAt) {
        return false
    }

    // Mongo/Motor devolve UTC sem offset nesta aplicacao. JavaScript trataria
    // esse ISO como horario local; acrescentar Z evita um timeout adiantado ou
    // atrasado conforme o fuso do navegador.
    const hasTimezone = /(Z|[+-]\d{2}:?\d{2})$/i.test(classificationRequestedAt)
    const utcTimestamp = hasTimezone
        ? classificationRequestedAt
        : `${classificationRequestedAt}Z`
    const elapsed = Date.now() - new Date(utcTimestamp).getTime()
    return Number.isFinite(elapsed) && elapsed > CLASSIFICATION_TIMEOUT_MS
}
